import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Button } from "antd";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import DataFreightControlTable from "./components/data-freight-control-table";

import { canViewFreightControlPanel } from "../../util/freight/freight-control-permissions";

require("firebase/auth");

function FreightControlPanel() {
  const userLogado = useSelector((state) => state.usuarioLogado);
  const user = useSelector((state) => state.user);
  const [cleanFilters, setCleanFilters] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);

  const canView = canViewFreightControlPanel(user);

  useEffect(() => {
    if (userLogado > 0) return;
  }, [userLogado]);

  if (userLogado <= 0) {
    return <Navigate to="/login" />;
  }

  if (!canView) {
    return <Navigate to="/" />;
  }

  return (
    <NewMiniDrawer
      divOpen={
        <div className="freight-content">
          <div
            className="container"
            style={{ marginRight: "unset", marginLeft: "unset" }}
          >
            <div className="row">
              <div className="col-5">
                <h3>Faturas</h3>
              </div>
              <div className="col-3" />
              <div className="col-1">
                <Button
                  type="primary"
                  onClick={() => setCleanFilters(!cleanFilters)}
                  className="btn-limpar-filtros"
                >
                  Limpar Filtros
                </Button>
              </div>
              <div
                style={{ marginLeft: "1.5%" }}
                className="col-1"
                onClick={() => setOpenFilters(!openFilters)}
              >
                <Button>Filtros Salvos</Button>
              </div>
            </div>
            <br />
            <br />
          </div>
          <DataFreightControlTable
            cleanFilter={cleanFilters}
            openFilter={openFilters}
            onCleanFilterHandled={() => setCleanFilters(false)}
            onOpenFilterHandled={() => setOpenFilters(false)}
          />
        </div>
      }
    />
  );
}

export default FreightControlPanel;

export {
  sendFreightInvoiceBoletoFromPanel,
  sendFreightInvoiceChargeFromPanel,
} from "./freightInvoiceEmailHandlers";
